export enum Ui89Theme {
  primary = "primary",
  secondary = "secondary",
  info = "info",
  success = "success",
  warning = "warning",
  danger = "danger",
}

export enum Ui89Look {
  main = "main",
  side = "side",
}
